import { render, staticRenderFns } from "./category.vue?vue&type=template&id=11e05f92&lang=pug"
import script from "./category.vue?vue&type=script&lang=coffee"
export * from "./category.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports